import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Refer from "@/pages/Refer";

export const Route = createFileRoute("/_public/refer")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Referral Program \u2014 Give $100, Get $100 | Modern Fence Install", "Refer a friend to Modern Fence Install. When their fence is installed, you get $100 in credit toward future work \u2014 automatically.", "/refer", false),
  component: Refer,
});
